import { render, staticRenderFns } from "./TestimonialInvitation.vue?vue&type=template&id=487efa7a&scoped=true"
import script from "./TestimonialInvitation.vue?vue&type=script&lang=js"
export * from "./TestimonialInvitation.vue?vue&type=script&lang=js"
import style0 from "@lp/components/mixins/medium-editor.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TestimonialInvitation.vue?vue&type=style&index=1&id=487efa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487efa7a",
  null
  
)

export default component.exports